<template>
	<el-dialog :close-on-click-modal="false"
		:title="$t('layout.pay')"
		:visible.sync="recModel" 
		top="5vh"
		:width="is_phone?'90%':'80%'"
		:append-to-body="true"
		custom-class="custom-dialog">
		<!-- 表单内容 -->
		<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="sub" :label-width="is_phone?'80px':'100px'">
			
			<!-- 充值选择 -->
	        <el-form-item v-if="check_id==0" :label="$t('upay.money')" prop="money">
				<el-input v-model="sub.money"  :placeholder="$t('upay.money')" clearable size="small" style="width: 85%;" type="number"
				@input="onMoneyInput"
				  @blur="onMoneyBlur"
				>
				<template slot="append">USDT</template>
				</el-input>
				<div style="color: gray;font-size: 12px;">{{$t('upay.tis')}}</div>
			</el-form-item>
	        <el-form-item v-if="check_id==0" :label="$t('upay.remark')" prop="remark">
				<el-input v-model="sub.remark"  maxlength="255" :placeholder="$t('upay.remark')" clearable size="small" style="width: 85%;" ></el-input>
			</el-form-item>
			
			
			<!-- 展示充值信息 -->
			<!-- 展示充值信息（替换此块） -->
			<!-- 展示充值信息（已分离：仅模板、带 class；数值/状态走方法） -->
			<div v-if="check_id!=0" class="pay-result" v-loading="loading">
			  <!-- 顶部状态条 -->
			  <div class="pay-topbar">
			    <el-tag :type="statusType(form.status)" effect="dark" size="small">
			      {{ statusText(form.status) }}
			    </el-tag>
			    <span v-if="form.order_no" class="pay-order-no">{{$t('upay.order_no')}}：{{ form.order_no }}
				<span class="iconCopy" @click="copyText(form.order_no)"><i class="iconfont icon-fuzhi"></i></span>
				</span>
			  </div>
			
			  <div class="pay-result-grid">
			    <!-- 左：二维码 -->
			    <div class="pay-qr-col">
			      <qrcode-vue :value="form.wallet_address" :size="160" level="H" />
			      <div class="pay-qr-tips">{{$t('upay.tis1')}}</div>
			    </div>
			
			    <!-- 右：信息 -->
			    <div class="pay-info-col">
			      <div class="pay-amount-box">
			        <div class="pay-amount-label">{{$t('upay.tis2')}}</div>
			        <div class="pay-amount">
			          <span class="pay-amount-num">{{ microToUSDT(form.real_amount) }}</span>
			          <span class="pay-amount-unit">USDT</span>
			        </div>
			        <div class="pay-amount-desc">{{$t('upay.tis3')}}</div>
			      </div>
			
			      <el-divider></el-divider>
			
			      <div class="pay-kv">
			        <div class="pay-k">{{$t('upay.tis4')}}</div>
			        <div class="pay-v">{{ microToUSDT(form.amount) }} USDT</div>
			      </div>
			
			      <div class="pay-kv">
			        <div class="pay-k">{{$t('upay.wallet_address')}}</div>
			        <div class="pay-v pay-mono">
					{{ form.wallet_address }}
					
					<span class="iconCopy" @click="copyText(form.wallet_address)"><i class="iconfont icon-fuzhi"></i></span>
					</div>
			      </div>
			
			      <div class="pay-kv" v-if="form.expire_time && !showCountdown">
			        <div class="pay-k">{{$t('upay.tis5')}}</div>
			        <div class="pay-v">{{ form.expire_time }}</div>
			      </div>
				  
				  <div class="pay-kv" >
				    <div class="pay-k">{{$t('upay.remark')}}</div>
				    <div class="pay-v">{{ form.remark }}</div>
				  </div>
				  
				  <!-- 剩余时间（仅 pending 且未过期时显示） -->
				  <!-- 漂亮倒计时卡片（仅 pending 且未过期展示） -->
				  <div v-if="showCountdown" class="cd-card" :class="{ urgent: remainingSeconds <= 60 }">
				    <div class="cd-header">
				      <i class="el-icon-time"></i>
				      <span class="cd-title">{{$t('upay.tis6')}}</span>
				      <el-tag v-if="form.expire_time" size="mini" type="info" effect="plain">{{$t('upay.tis7')}} {{ form.expire_time }}</el-tag>
				      <span class="cd-spacer"></span>
				      <el-tag size="mini" type="warning" v-if="form.status==='pending'">{{$t('upay.pending')}}</el-tag>
				    </div>
				  
				    <div class="cd-digits">
				      <span class="cd-block">{{ hms.h }}</span>
				      <span class="cd-sep">:</span>
				      <span class="cd-block">{{ hms.m }}</span>
				      <span class="cd-sep">:</span>
				      <span class="cd-block">{{ hms.s }}</span>
				    </div>
				  
				    <!-- 剩余进度（有 total 才显示） -->
				    <el-progress
				      v-if="progressPercent !== null"
				      class="cd-progress"
				      :percentage="progressPercent"
				      :stroke-width="8"
				      :show-text="false"
				    />
				  
				    <div class="cd-sub">{{$t('upay.tis8')}}</div>
				  
				  <!-- 取消、完成按钮 -->
				    <div class="cd-actions">
				      <el-button type="danger" size="mini" :disabled="loading" :loading="loading" @click="cancelOrder">{{$t('upay.qx')}}</el-button>
				      <el-button  :disabled="loading  || isRefreshing || cooldownSec > 0" :loading="loading || isRefreshing" size="mini" type="success" @click="checkUpayStatus('click')">
					  
					 
					  
					  {{ $t('upay.tis9')  }}  
					  <span v-if="cooldownSec > 0">({{ cooldownSec }}s)</span>
					  
					  </el-button>
				    </div>
				  </div>

			
			      <el-alert
			        class="pay-warn"
			        type="warning"
			        :closable="false"
			        show-icon
			        :title="$t('upay.tis10')"
			      />
			    </div>
			  </div>
			</div>


			
			
	        
	        
		</el-form>
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{check_id==0?$t('system.cancel'):$t('cdnd.close')}}</el-button>
		
			
			<el-button type="primary" v-if="check_id==0" :loading="loading" :disabled="loading" @click="submit">{{$t('system.confirm')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import QrcodeVue from 'qrcode.vue';
	import { commondecrypt } from '@/main';
	export default {
		components: { QrcodeVue },
		inject: ['app'],
		props: {
			recModel: {
				type: Boolean,
				default: false
			},
			
			is_phone: {
				type: Boolean,
				default: false
			},
			check_id:{
				type:Number,
				default:0
			}
		},
		data() {
			return {
				sub:{
					money:'',
					remark:''
				},
				form:{

				},
				loading:false,
				remainingSeconds: 0,
				countdownTimer: null,
				refreshing: false, // 如果你有“刷新状态”按钮可复用
				rules: {
					money: [{
							required: true,
							message: this.$t('upay.inpmoney'),
							trigger: 'blur',
						},
					]
				},
				isRefreshing: false,   // 短暂加载态（一次点击的一次刷新）
				cooldownSec: 0,        // 冷却倒计时（秒）
				_cooldownTimer: null,  // 内部计时器
			}
		},
		watch: {
		  // 进入展示阶段或关闭时，启动/停止倒计时
		  // check_id(val) {
		  //   if (val !=0) this.resetCountdownFrom(this.form.expire_time);
		  //   else this.clearCountdown();
		  // },
		  // 弹窗显隐变化时的兜底（如果你用的是 recModel 控制弹窗）
		  recModel(val) {
		    // if (val && this.check_id !=0 ) this.resetCountdownFrom(this.form.expire_time);
		    // else if (!val) this.clearCountdown();
			this.changeModelStatus()
		  },
		  // 服务器返回的新截止时间
		  'form.expire_time': {
		    immediate: true,
		    handler(val) { if (this.check_id !=0) this.resetCountdownFrom(val); }
		  },
		  // 非 pending 状态就停止倒计时
		  'form.status'(val) {
		    if (val !== 'pending') this.clearCountdown();
		  },
		},
		computed: {
		  // 仅在展示阶段 + 待支付 + 还有剩余秒数 时显示倒计时
		  showCountdown() {
		      return this.check_id !=0 && this.form.status === 'pending' && this.remainingSeconds > 0;
		    },
		    // 分/秒分离成三段，便于大号美化显示
		    hms() {
		      const s = Math.max(0, this.remainingSeconds | 0);
		      const h = Math.floor(s / 3600);
		      const m = Math.floor((s % 3600) / 60);
		      const sec = s % 60;
		      const pad = n => String(n).padStart(2, '0');
		      return { h: pad(h), m: pad(m), s: pad(sec) };
		    },
		    // 计算剩余百分比（需有总时长：优先使用 created_at/createdAt）
		    progressPercent() {
		      const end = this.getExpireTs(this.form.expire_time);
		      const created = this.getExpireTs(this.form.create_time);
		      if (!end || !created || end <= created) return null;        // 没有总时长则不显示
		      const total = Math.max(1, Math.floor((end - created) / 1000));
		      const left  = Math.max(0, this.remainingSeconds);
		      return Math.round((left / total) * 100);                    // 剩余百分比
		    },
		},
		beforeDestroy() {
		  this.clearCountdown();
		  if (this._cooldownTimer) clearInterval(this._cooldownTimer);
		},
		methods:{
			changeStatus(id,status){
				this.$emit('changeStatus',id,status)
			},
			cancelOrder(){
				this.$confirm(this.$t('upay.confrim_warn3'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.loading = true;
					let url = '/admin/user/cancelUpay'
					this.axios.post(url, {id:this.check_id}, {
						token: true,
						loading: true
					}).then(res => {
						let all = res.data
						
						if (all.code == 1) {
							let list = all.data.list
							console.log(list)
							if(this.recModel){
								this.form.status = list
								
								this.changeStatus(this.check_id,this.form.status)
								this.$message({
									message: res.data.msg,
									type: 'success'
								});
							}
							
						}
						
						
						this.loading = false;
					}).catch(err => {
						this.loading = false;
						
					})
				})
				
			},
			changeModelStatus(){
				if(this.recModel && this.check_id !=0){
					this.checkUpayStatus()
					
				}else{
					this.clearCountdown();
				}
			},
			
			checkUpayStatus(from='to'){
				if(from=='click'){
					if (this.cooldownSec > 0 || this.isRefreshing) return;
					this.isRefreshing = true;
				}
				this.loading = true;
				let url = '/admin/user/checkUpayStatus'
				this.axios.post(url, {id:this.check_id}, {
					token: true,
					loading: true
				}).then(res => {
								
					let all = res.data
					let list = all.data.list
					console.log(list)
					if(from=='end'){
						this.form.status = list.status
					}else{
						this.form = list
					}
					
					
					this.loading = false;
					if(from=='click'){
						this.isRefreshing = false
						this.startCooldown(3);
					}
					this.changeStatus(this.check_id,this.form.status)
				}).catch(err => {
					this.loading = false;
					if(from=='click'){
						this.isRefreshing = false
						this.startCooldown(3);
					}
				})
			},
			startCooldown (sec = 3) {
			    this.cooldownSec = sec;
			    if (this._cooldownTimer) clearInterval(this._cooldownTimer);
			    this._cooldownTimer = setInterval(() => {
			      this.cooldownSec -= 1;
			      if (this.cooldownSec <= 0) {
			        clearInterval(this._cooldownTimer);
			        this._cooldownTimer = null;
			        this.cooldownSec = 0;
			      }
			    }, 1000);
			  },
			
			getExpireTs(str) {
			    if (!str) return 0;
			    // ISO 末尾 Z 按 UTC，其余用本地时区（兼容 Safari）
			    const d = /Z$/i.test(str) ? new Date(str) : new Date(String(str).replace(/-/g, '/'));
			    const ts = d.getTime();
			    return Number.isFinite(ts) ? ts : 0;
			  },
			
			  // 根据 expire_time 重置并启动计时
			  resetCountdownFrom(expireStr) {
			    this.clearCountdown();
			    const endTs = this.getExpireTs(expireStr);
			    if (!endTs) return;
			
			    const diff = Math.floor((endTs - Date.now()) / 1000);
			    this.remainingSeconds = Math.max(0, diff);
			    if (this.form.status === 'pending' && this.remainingSeconds > 0) {
			      this.countdownTimer = setInterval(this.tickCountdown, 1000);
			      // 先立即刷新一次
			      this.tickCountdown();
			    } else if (this.remainingSeconds <= 0) {
			      // 已过期，通知父级（不直接改 props）
				  this.checkUpayStatus('end')
			      //this.$emit('expired', { order_no: this.form.order_no });
			    }
			  },
			
			  // 每秒刷新
			  tickCountdown() {
			    const endTs = this.getExpireTs(this.form.expire_time);
			    const diff = Math.floor((endTs - Date.now()) / 1000);
			    this.remainingSeconds = Math.max(0, diff);
			    if (this.remainingSeconds <= 0) {
			      this.clearCountdown();
			      // 到期通知父级自行把 form.status 改为 'expired'
				  this.checkUpayStatus('end')
			      this.$emit('expired', { order_no: this.form.order_no });
			    }
			  },
			
			  // 清理定时器
			  clearCountdown() {
			    if (this.countdownTimer) {
			      clearInterval(this.countdownTimer);
			      this.countdownTimer = null;
			    }
			  },
			microToUSDT(n) {
			    const v = Number(n || 0) / 1e6;
			    return v.toFixed(6).replace(/\.?0+$/, '');
			  },
			
			  // 状态 -> el-tag 类型
			  statusType(status) {
			    const map = {
			      pending: 'warning',
			      paid: 'success',
			      expired: 'info',
			      canceled: 'info',
			    };
			    return map[status] || 'info';
			  },
			
			  // 状态 -> 文案（如需 i18n 可替换为 this.$t(...)）
			  statusText(status) {
			    const map = {
			      pending: this.$t('upay.pending'),
			      paid: this.$t('upay.paid'),
			      expired: this.$t('upay.expired'),
			      canceled: this.$t('upay.canceled'),
			    };
			    return map[status] || status || this.$t('upay.no');
			  },
			onMoneyInput(val) {
			    // 只保留数字，去掉前导 0
			    let s = String(val || '').replace(/[^\d]/g, '').replace(/^0+(?=\d)/, '');
			    this.sub.money = s;
			  },
			  onMoneyBlur() {
			    // 失焦兜底：空/0 置空，其他取整数
			    const n = parseInt(this.sub.money, 10);
			    this.sub.money = (!n || n < 1) ? '' : String(n);
			  },
			hide(){
				this.$emit('hide')
			},
			submit() {
			
				this.$refs.form.validate(res => {
					
					if (res) {
						this.subUpayApi()
						// 關閉模态框
					}
				})
			},
			
			successSub(id){
				this.$emit('successSub',id)
			},
			subUpayApi(){
				
				this.$confirm(this.$t('upay.confrim_warn')+this.sub.money+' USDT '+this.$t('upay.confrim_warn2'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.loading = true;
					let url = '/admin/user/submitUpay'
					this.axios.post(url, this.sub, {
						token: true,
						loading: true
					}).then(res => {
						let all = res.data
						
						if (all.code == 1) {
							let list = all.data.list
							
							this.form = list
							this.$message({
								message: res.data.msg,
								type: 'success'
							});
							
							this.successSub(list.id)
						}
						
						
						this.loading = false;
					}).catch(err => {
						this.loading = false;
					})
				})
			},
			copyText(text) {
			  
				//console.log(111)
			  navigator.clipboard.writeText(text)
				.then(() => {
				  this.$message.success(this.$t('cdn.copy_ok'));
				})
				.catch(() => {
				  this.$message.error(this.$t('cdn.copy_fail'));
				});
			},
			
			
			
			
			
			
			
		}
	}
</script>

<style>
	/* 充值结果展示 */
	.pay-result {
	  max-height: 65vh;
	  overflow: auto;
	}
	
	/* 顶部状态条 */
	.pay-topbar {
	  display: flex;
	  align-items: center;
	  gap: 12px;
	  margin-bottom: 12px;
	}
	.pay-order-no {
	  color: #909399;
	  font-size: 13px;
	}
	
	/* 主体两栏布局 */
	.pay-result-grid {
	  display: grid;
	  grid-template-columns: 240px 1fr;
	  gap: 24px;
	}
	@media (max-width: 720px) {
	  .pay-result-grid {
	    grid-template-columns: 1fr;
	  }
	}
	
	/* 左侧二维码列 */
	.pay-qr-col {
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  
	}
	.pay-qr-tips {
	  margin-top: 8px;
	  font-size: 12px;
	  color: #909399;
	  text-align: center;
	  line-height: 1.6;
	}
	
	/* 右侧信息列 */
	.pay-info-col {
	  min-width: 0;
	}
	
	/* 实付金额卡片 */
	.pay-amount-box {
	  background: linear-gradient(135deg, #f0f9ff 0%, #ecf5ff 100%);
	  border: 1px solid #e4f0ff;
	  border-radius: 12px;
	  padding: 16px;
	}
	.pay-amount-label {
	  color: #409eff;
	  font-weight: 600;
	  margin-bottom: 6px;
	}
	.pay-amount {
	  display: flex;
	  align-items: baseline;
	  gap: 8px;
	}
	.pay-amount-num {
	  font-size: 28px;
	  font-weight: 700;
	}
	.pay-amount-unit {
	  font-size: 14px;
	  color: #606266;
	}
	.pay-amount-desc {
	  margin-top: 6px;
	  font-size: 12px;
	  color: #909399;
	}
	
	/* 关键信息 key-value 行 */
	.pay-kv {
	  display: grid;
	  grid-template-columns: 120px 1fr;
	  gap: 8px;
	  align-items: center;
	  margin: 10px 0;
	  font-size: 14px;
	}
	.pay-k {
	  color: #909399;
	}
	.pay-v {}
	.pay-mono {
	  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
	  word-break: break-all;
	}
	
	/* 警告提示 */
	.pay-warn {
	  margin-top: 8px;
	}
	
	/* 倒计时文本 */
	/* 倒计时卡片 */
	.cd-card {
	  margin-top: 8px;
	  padding: 14px;
	  border-radius: 12px;
	  background: linear-gradient(135deg, #f5faff 0%, #eef6ff 100%);
	  border: 1px solid #e6f0ff;
	  box-shadow: 0 2px 10px rgba(64, 158, 255, 0.06);
	  transition: box-shadow 0.2s ease, border-color 0.2s ease;
	}
	.cd-card.urgent {
	  border-color: #ffd9d9;
	  box-shadow: 0 2px 12px rgba(245, 108, 108, 0.18);
	}
	
	/* 头部 */
	.cd-header {
	  display: flex;
	  align-items: center;
	  gap: 8px;
	  color: #606266;
	  margin-bottom: 8px;
	  font-size: 13px;
	}
	.cd-header .cd-title {
	  font-weight: 600;
	  color: #303133;
	}
	.cd-spacer { flex: 1; }
	
	/* 数字区 */
	.cd-digits {
	  display: flex;
	  align-items: baseline;
	  gap: 8px;
	  margin: 4px 0 8px;
	}
	.cd-block {
	  min-width: 48px;
	  padding: 6px 8px;
	  border-radius: 10px;
	  background: #111827;
	  color: #fff;
	  text-align: center;
	  font-size: 24px;
	  font-weight: 700;
	  letter-spacing: 1px;
	  font-variant-numeric: tabular-nums;
	  line-height: 1;
	  box-shadow: inset 0 -2px 0 rgba(255,255,255,0.08);
	}
	.cd-sep {
	  font-size: 22px;
	  color: #606266;
	  width: 10px;
	  text-align: center;
	  animation: cd-blink 1s steps(2, jump-none) infinite;
	}
	.cd-card.urgent .cd-block {
	  background: #2d0606;
	  color: #ffeded;
	  box-shadow: inset 0 -2px 0 rgba(255,255,255,0.06);
	}
	@keyframes cd-blink { 50% { opacity: 0.35; } }
	
	/* 进度条 */
	.cd-progress { margin-top: 4px; }
	
	/* 辅助文本与按钮 */
	.cd-sub {
	  margin-top: 6px;
	  font-size: 12px;
	  color: #909399;
	}
	.cd-actions {
	  margin-top: 10px;
	  display: flex;
	  gap: 10px;
	  flex-wrap: wrap;
	}


</style>
